import React, { useState, useEffect } from 'react';
import './Home.css';

// Video URLs - use same origin as frontend to ensure dev uses dev content, prod uses prod content
const videoBaseUrl = window.location.hostname === 'localhost'
  ? 'http://localhost:3001'  // Local dev server
  : window.location.origin;   // Use same domain as frontend (dev.axiomteq.com or axiomteq.com)
const videoSources = [
  `${videoBaseUrl}/uploads/main.mp4`,
];

const Home: React.FC = () => {
  const [videoLoading, setVideoLoading] = useState(true);
  const [videoError, setVideoError] = useState(false);

  // Remove duplicate video preloading - the main video element will handle loading
  useEffect(() => {
    // Set initial loading state - the actual video element will handle the loading
    setVideoLoading(true);
    setVideoError(false);
  }, []); // No dependencies needed

  const handleVideoLoaded = () => {
    setVideoLoading(false);
    setVideoError(false);
  };

  const handleVideoError = (e: React.SyntheticEvent<HTMLVideoElement, Event>) => {
    console.log('Video failed to load, showing fallback');
    setVideoLoading(false);
    setVideoError(true);
  };

  const handleVideoLoadStart = () => {
    setVideoLoading(true);
    setVideoError(false);
  };

  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-container">
          <div className="hero-content">
            {/* Action Button */}
            <div className="hero-buttons">
              <button
                onClick={() => {
                  const element = document.getElementById('products');
                  if (element) element.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }}
                className="btn btn-primary btn-large"
              >
                Explore Solutions
              </button>
            </div>
          </div>
          <div className="hero-video">
            {/* Video Loading Indicator */}
            {videoLoading && !videoError && (
              <div className="video-loading">
                <div className="loading-spinner"></div>
                <p>Loading...</p>
              </div>
            )}
            
            {/* Main Video - Only show if not in error state */}
            {!videoError && (
              <video 
                className="hero-video-element"
                autoPlay 
                loop 
                muted 
                playsInline
                preload="metadata"
                crossOrigin="anonymous"
                onLoadStart={handleVideoLoadStart}
                onCanPlay={handleVideoLoaded}
                onError={handleVideoError}
                onLoadedData={handleVideoLoaded}
                style={{ 
                  opacity: videoLoading ? 0 : 1,
                  willChange: 'opacity'
                }}
              >
                <source src={videoSources[0]} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            )}
            
            {/* Video Overlay */}
            <div className="hero-video-overlay"></div>
            
            {/* Enhanced Fallback for video error or missing video */}
            {videoError && (
              <div className="hero-video-fallback" style={{ 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                flexDirection: 'column',
                height: '100%',
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                color: 'white',
                textAlign: 'center'
              }}>
                <span className="placeholder-icon" style={{ fontSize: '4rem', marginBottom: '1rem' }}>🚀</span>
                <h3 style={{ marginBottom: '0.5rem', fontSize: '2rem' }}>AxiomTeq</h3>
                <p style={{ fontSize: '1.2rem', opacity: 0.9 }}>Innovation at Scale</p>
                <div className="video-pattern" style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  opacity: 0.1,
                  background: 'url("data:image/svg+xml,%3Csvg width="40" height="40" viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="white" fill-opacity="0.3"%3E%3Cpath d="M20 20c0 5.5-4.5 10-10 10s-10-4.5-10-10 4.5-10 10-10 10 4.5 10 10z"/%3E%3C/g%3E%3C/svg%3E")'
                }}></div>
              </div>
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home; 